import { IStoreGroup } from 'src/interfaces/storeGroup';
import { CLEAR_STATE, SET_LOADING } from '../types';
import {
    CREATE_STORE_GROUP,
    DELETE_STORE_GROUP,
    GET_STORE_GROUP,
    GET_STORE_GROUPS,
    UPDATE_STORE_GROUP,
} from './constants/actions';
import { IStoreGroupInitialState, TStoreGroupActionTypes } from './types';
import { updateStoreGroupState } from './utils';

export default (
    state: IStoreGroupInitialState,
    action: TStoreGroupActionTypes
): IStoreGroupInitialState => {
    switch (action.type) {
        case GET_STORE_GROUPS:
            return updateStoreGroupState(state, {
                storeGroups: action.payload,
                count: action.count,
            });

        case GET_STORE_GROUP:
            return updateStoreGroupState(state, { storeGroup: action.payload });

        case CREATE_STORE_GROUP:
            return updateStoreGroupState(state, {});

        case DELETE_STORE_GROUP:
            return updateStoreGroupState(state, {
                storeGroups: (state.storeGroups || []).filter(
                    (group) => group._id.toString() !== action.payload.toString()
                ),
                storeGroup: null,
            });

        case UPDATE_STORE_GROUP: {
            let updatedStoreGroups: IStoreGroup[] = state?.storeGroups || [];
            if (!Array.isArray(action.payload)) {
                const payload: IStoreGroup = action.payload;

                const updatedIndex = updatedStoreGroups.findIndex(
                    (group: IStoreGroup) => group?._id === payload._id
                );

                if (updatedIndex !== -1)
                    updatedStoreGroups[updatedIndex] = action.payload;
            }
            return updateStoreGroupState(state, {
                storeGroups: updatedStoreGroups,
                storeGroup: action.payload,
            });
        }

        case CLEAR_STATE:
            return action.payload;
        case SET_LOADING:
            return updateStoreGroupState(state, { loading: true });
        default:
            return state;
    }
};
